export default {
  sendEmail: {
    data: null,
    error: null,
    loading: false,
  },
};
